import { React, useRef, useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';

export default function EstimateItem(props) {


    return (
        <div className='EstimateSummaryItem'>
            {
                props.container.summary
            }
            <div className='EstimateSummaryItemQuantity'>
                <div style={{fontWeight:'normal'} }>

                    <div style={{ fontWeight: 'bold' }}>Quantity: {props.container.Quantity} </div>
                    <div>{props.container.Fullness} Full {props.container.ContainerName}{props.container.Quantity == 1 ? null : 's'}{props.container.Description === '' ? null : ' of:'}</div>
                    {props.container.Description === '' ? null
                        :
                        <div>{props.container.Description.replace('Content: ', '')}</div>
                    }
                    <div>Estimated Count{props.container.Quantity == 1 ? null : ' each' }: {props.container.ReturnableCount}</div>
                </div>
            </div>



        </div>
    );
}